import { render, staticRenderFns } from "./SparePartUsingHistoryStep.vue?vue&type=template&id=081b1234"
import script from "./SparePartUsingHistoryStep.vue?vue&type=script&lang=ts"
export * from "./SparePartUsingHistoryStep.vue?vue&type=script&lang=ts"
import style0 from "./SparePartUsingHistoryStep.vue?vue&type=style&index=0&id=081b1234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports